import * as React from 'react';

/**
 * Settings subsection chrome — item 10 Option C (tint band).
 * Primary-tint fill `#E7F0EC` + jade ink. Softest of the three mockups;
 * same filled-band shape as module summary tables, not the solid jade fill.
 */
export function SettingsSectionCard({
    title,
    description,
    actions,
    children,
    footer,
}: {
    title?: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
}) {
    return (
        <section className="overflow-hidden rounded-xl border border-outline-variant bg-card shadow-teal">
            {(title || actions || description) && (
                <header className="flex min-h-12 flex-wrap items-center justify-between gap-2.5 border-b border-primary/12 bg-primary-tint px-3 py-1.5">
                    <div className="min-w-0">
                        {title && (
                            <h3 className="text-[11px] font-bold uppercase tracking-[0.06em] text-primary-dim">
                                {title}
                            </h3>
                        )}
                        {description && (
                            <p className="mt-1 text-sm font-normal normal-case tracking-normal text-muted-foreground">
                                {description}
                            </p>
                        )}
                    </div>
                    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
                </header>
            )}
            <div className="px-5 py-4">{children}</div>
            {footer && (
                <div className="flex items-center justify-between border-t border-outline-variant bg-muted/30 px-5 py-3">
                    {footer}
                </div>
            )}
        </section>
    );
}
